import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from '@/components/Icons/ChevronDown';
import { recipientStatusIcon } from '@/pages/Mail/mailRecipients';
import type { MailRecipient } from '@/types/mail';

interface Props {
  recipients: MailRecipient[];
  isExpanded: boolean;
}

export const MailDetailRecipients: React.FC<Props> = ({
  recipients,
  isExpanded,
}) => {
  const { t } = useTranslation();
  const [first] = recipients;
  const restCount = recipients.length - 1;
  const hasMultipleRecipients = restCount > 0;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex w-full items-center gap-1">
        <p className="min-w-0 flex-1 truncate text-body-14 text-subtle-foreground">
          {t('mail.detail.to')} {first.name}
          {hasMultipleRecipients &&
            ` ${t('mail.detail.recipientsCount', { count: restCount })}`}
        </p>
        {hasMultipleRecipients && (
          <ChevronDown
            className={`size-4 shrink-0 text-subtle-foreground transition-transform ${isExpanded ? 'rotate-180' : ''}`}
          />
        )}
      </div>

      {isExpanded && (
        <div className="flex flex-wrap gap-2">
          {recipients.map((recipient) => (
            <span
              key={recipient.id}
              className="flex items-center gap-1 rounded-[40px] bg-info-surface px-3 py-2 text-caption-12 text-foreground"
            >
              {recipient.name}
              {recipientStatusIcon[recipient.status]}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
